import React from 'react';
import { BannerList } from 'src/components/BannerList';
import { CarouselBannerUI } from 'src/components/CarouselBanner';
import { CategoryCarousel } from 'src/components/CategoryCarousel';
import { ProductCard3 } from 'src/components/ProductCard3';
import { AuthWrapper } from 'src/features/core/auth/screen/AuthWrapper';
import { Banners } from 'src/model/Banners';
import { Category } from 'src/model/Category';
import { Product } from 'src/model/Product';
import Client from 'src/model/User';

interface HomeUIProps {
  product: Product[];
  productsLoading: boolean;
  categories: Category[];
  banners: Banners[];
  bannerService: Banners[];
  bannerImages: Banners[];
  bannerMidleImages: Banners[];
  valuePrice: (product: Product, discount: boolean) => string;
  goCategory: (id: string) => void;
  goSlide?: (id: string) => void;
  user?: Client;
}

export const HomeUI: React.FC<HomeUIProps> = ({
  product,
  productsLoading,
  categories,
  banners,
  bannerService,
  bannerImages,
  bannerMidleImages,
  goCategory,
  goSlide,
  valuePrice,
  user,
}) => {
  const userCity =
    user?.address?.find((addr) => addr.main)?.city || user?.address?.[0]?.city;
  console.log('User City:', user);
  console.log('User City:', userCity);
  return (
    <AuthWrapper>
      <div className="w-full grid grid-cols-1 justify-items-center">
        <div className="md:block w-full">
          <CarouselBannerUI
            slides={Array.isArray(banners) ? banners : []}
            hideIndicators={false}
            hideControls={false}
            goSlide={goSlide}
            className="aspect-[4/2] md:aspect-[10/3]"
          />
        </div>

        <div className="hidden w-full">
          <CarouselBannerUI
            slides={Array.isArray(banners) ? banners : []}
            hideIndicators={false}
            hideControls={false}
            goSlide={goSlide}
            className="aspect-[4/2] md:aspect-[10/3]"
          />
        </div>

        <div className="w-full flex flex-wrap justify-center lg:flex-nowrap items-center mb-2 bg-gray-200 max-h-full">
          <div className="w-full flex justify-center p-6 md:mt-0">
            <BannerList bannerListData={bannerService ?? []} />
          </div>
          <div className="w-full h-[10rem] md:w-[33rem]">
            <CarouselBannerUI
              slides={Array.isArray(bannerImages) ? bannerImages : []}
              hideIndicators={true}
              hideControls={true}
              goSlide={goSlide}
              className="w-full h-[10rem] md:w-[33rem] object-cover"
            />
          </div>
        </div>

        <div className="max-w-[1152px] flex justify-center items-center">
          {categories && categories.length > 0 && (
            <CategoryCarousel
              categories={Array.isArray(categories) ? categories : []}
              goCategory={goCategory}
            />
          )}
        </div>

        <div className="w-[1152px] mt-5 md:mt-0 justify-items-center">
          <div className="w-full h-[5rem] px-2 mb-10 md:mb-5 md:w-full md:h-[200px] lg:w-full lg:h-[160px] max-w-[35%] mx-auto sm:max-w-full">
            <CarouselBannerUI
              slides={Array.isArray(bannerMidleImages) ? bannerMidleImages : []}
              hideIndicators={true}
              hideControls={true}
              goSlide={goSlide}
              className="w-full h-[5rem] md:w-full md:h-[200px] lg:w-full lg:h-[160px]"
            />
          </div>
        </div>

        <div className="max-w-[1152px] mt-5 md:mt-0 justify-items-center">
          {productsLoading ? (
            <div className="flex flex-col items-center justify-center py-20">
              <div className="flex space-x-2">
                <div
                  className="w-3 h-3 bg-red-500 rounded-full animate-bounce"
                  style={{ animationDelay: '0s' }}
                ></div>
                <div
                  className="w-3 h-3 bg-red-500 rounded-full animate-bounce"
                  style={{ animationDelay: '0.2s' }}
                ></div>
                <div
                  className="w-3 h-3 bg-red-500 rounded-full animate-bounce"
                  style={{ animationDelay: '0.4s' }}
                ></div>
              </div>
              <p className="text-gray-600 mt-4 text-sm">
                Carregando produtos...
              </p>
            </div>
          ) : Array.isArray(product) && product.length > 0 ? (
            <ProductCard3
              products={product}
              valuePrice={valuePrice}
              userCity={userCity}
            />
          ) : (
            <div className="text-center py-10">
              <p className="text-gray-500">
                Nenhum produto disponível no momento.
              </p>
            </div>
          )}
        </div>
      </div>
    </AuthWrapper>
  );
};
